
import Vue from "vue";
export default Vue.extend({
  name: "image-content-card",
  data() {
    return {};
  },
  props: {
    imageSrc: { default: "", type: String },
    imageAlt: { default: "", type: String },
    title: { default: "", type: String },
    titleTo: { default: "", type: String },
    content: { default: "", type: String },
    hashTo: { default: "", type: String },
  },
});
